<template>
	<div>
		<img :src="qrcodeImg" alt="" class="qrcodeImg" v-if="codeType === 'qrCode'" :style="{width:size+'px',height:size+'px'}">
		<img id="barcode" v-if="codeType === 'barCode'"></img>
	</div>
</template>

<script>
	import JsBarcode from 'jsbarcode'
	import jrQrcode from 'jr-qrcode'
	export default {
		data() {
			return {
				qrcodeImg: ''
			}
		},
		props: {
			code: {
				type: String,
				default: ''
			},
			codeType: { // 使用码类型 qrCode二维码 barCode条形码
				type: String,
				default: 'qrCode'
			},
			size: {
				type: [String, Number],
				default: 200
			}
		},
		mounted() {
			setTimeout(()=>{
				this[this.codeType === 'qrCode' ? 'createqQr' : 'createqBar'](this.code, this.size)
			},0)
		},
		methods: {
			createqQr(code, size = 200) {
				let imgBase64 = jrQrcode.getQrBase64(code, {
					padding: 10, // 二维码四边空白（默认为10px）
					width: size, // 二维码图片宽度（默认为200px）
					height: size, // 二维码图片高度（默认为200px）
					reverse: false, // 反色二维码，二维码颜色为上层容器的背景颜色
					background: '#ffffff', // 二维码背景颜色（默认白色）
					foreground: '#000000' // 二维码颜色（默认黑色）
				})
				this.qrcodeImg = imgBase64
			},
			createqBar(code) {
				console.log("code",code);
				JsBarcode('#barcode', String(code), {
					// format: 'auto', // 条形码的格式
					// lineColor: '#0aa', // 线条颜色
					width: 4, // 线宽
					height: 40, // 条码高度
					displayValue: false // 是否显示文字信息
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.code-box {
		padding: 6px;
	}

	.qrcodeImg,
	#barcode {
		display: block;
		margin: 0 auto;
	}
	#barcode{
		width: 500px;
		height: 110px;
		margin: 0 auto;
	}
</style>
